function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}, props), React.createElement("path", {
  d: "M11.711 0C5.283 0 0 5.238 0 11.711 0 16.29 5.723 23.202 9.157 26.9c.66.706 1.586 1.101 2.554 1.101.968 0 1.893-.395 2.554-1.1 3.434-3.698 9.157-10.611 9.157-15.189C23.422 5.241 18.14 0 11.712 0zm0 16.026c-2.376 0-4.357-1.937-4.357-4.358 0-2.377 1.936-4.358 4.357-4.358 2.377 0 4.358 1.937 4.358 4.358 0 2.42-1.981 4.358-4.358 4.358z",
  fill: "#858E96"
})));